import customSelect from 'custom-select';

class SelectDropdown {
  constructor() {
    this.config = {
      module: document.querySelectorAll('[data-module="SelectDropdown"]')
    };
  }

  init() {
    const { module } = this.config;

    if (
      !module.length ||
      !!(
        'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)
      )
    ) {
      return;
    }

    customSelect(module, {
      containerClass: 'c-select-dropdown',
      openerClass: 'c-select-dropdown__opener',
      panelClass: 'c-select-dropdown__panel',
      optionClass: 'c-select-dropdown__option',
      optgroupClass: 'c-select-dropdown__option-group'
    });
  }
}

export default SelectDropdown;
